export default "__VITE_ASSET__BqAzqY7S__"